const Style = {
    card: 'rounded-xl border border-border bg-surface shadow-sm',
    cardHeader: 'border-b border-border px-3.5 py-2.5',
    cardTitle: 'text-xs font-semibold uppercase tracking-wide text-text-secondary',

    rows: 'space-y-2.5 px-3.5 py-3',
    row: 'grid grid-cols-[6.5rem_minmax(0,1fr)] items-center gap-2',
    rowLabel: `flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide
        text-text-muted`,
    rowValue: 'min-w-0',

    value: 'flex flex-wrap items-center gap-1.5 text-sm text-text-primary',
    valueError: 'text-error',
    mono: 'font-mono text-xs text-text-secondary',
    muted: 'text-sm italic text-text-muted',

    priorityTrigger: `inline-flex cursor-pointer items-center gap-1 rounded-md border border-transparent
        px-1 py-0.5 transition-colors hover:border-border hover:bg-background
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
        disabled:pointer-events-none`,

    overdueTag: `rounded-md border border-error/35 bg-error/10 px-1.5 py-0.5 text-[10px] font-semibold
        uppercase tracking-wide text-error`,

    syncWarn: 'mx-3.5 mb-3 rounded-lg bg-warning/10 px-3 py-2 text-center text-sm text-warning',
};

export default Style;
